/**
 * AP Invoices Demo — entry point for the 3-way match dialog.
 *
 * THROWAWAY DEMO CODE. Renders a button + the production `ThreeWayMatchDialog`
 * only when the demo has 3-way data for this invoice (so it's inert otherwise).
 */

import { useState } from 'react';
import { GitMergeIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';
import { Button } from '@/components/ui/button';
import { ThreeWayMatchDialog } from '@/components/accounts-payable/invoice-detail/three-way-match-dialog';
import { useApThreeWayMatch } from './provenance';

export function ThreeWayMatchButton({ invoiceId }: { invoiceId: string }) {
  const data = useApThreeWayMatch(invoiceId);
  const [open, setOpen] = useState(false);

  if (!data) return null;

  return (
    <div className="px-1">
      <Button
        variant="outline"
        size="sm"
        className="gap-1.5"
        onClick={() => setOpen(true)}
      >
        <GitMergeIcon className="size-4 text-sky-600" />
        <T context="button opening the 3-way match dialog">
          Review 3-way match
        </T>
      </Button>
      <ThreeWayMatchDialog open={open} onOpenChange={setOpen} data={data} />
    </div>
  );
}
